/** Floor plan / table service domain types. */
export const FLOOR_GRID_SIZE = 100;
export const DEFAULT_ROOM = 'Main';
//# sourceMappingURL=table.js.map